<template>
  <!-- Modal -->
  <div
    class="modal fade"
    id="modal-base-useplace"
    tabindex="-1"
    role="dialog"
    aria-labelledby="TarafModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content rounded text-dark">
        <div class="modal-header bg-primary text-white rounded-top p-2">
          <h5 class="modal-title" id="TarafModalLabel">لیست مراکز هزینه</h5>
          <button
            type="button"
            class="close m-0 p-1"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span class="text-white" aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <!-- شروع تب حساب ها -->
          <div class="col p-0">
            <!-- تب های کد حساب -->
            <ul class="nav nav-tabs">
              <!-- تب لیست حساب ها -->
              <li class="nav-item activeNav rounded-top">
                <a
                  href="#tabTarafHesab-list"
                  id="home-tab"
                  class="
                    nav-link
                    active
                    d-flex
                    justify-content-between
                    align-items-center
                  "
                  data-toggle="tab"
                >
                  لیست مراکز هزینه ( {{ TbModalDataFilter.length | numFormat }} مورد
                  )
                </a>
              </li>
            </ul>

            <!-- بدنه تب های حساب ها -->
            <div class="tab-content rounded shadow z-depth-1 p-1">
              <!-- بدنه تب لیست حساب ها -->
              <div
                class="tab-pane fade show active w-100"
                id="tabTarafHesab-list"
              >
                <!-- جدول محتویات -->
                <div class="row p-2">
                  <div
                    id="TbModalData"
                    class="table-responsive"
                    style="max-height: 280px; overflow-y: auto"
                  >
                    <table
                      class="
                        table table-bordered table-sm
                        text-center
                        table-font-size
                      "
                    >
                      <!-- سربرگ جدول -->
                      <thead>
                        <td
                          class="bg-primary-light"
                          style="
                            position: sticky;
                            top: -1px;
                            border: 1px solid #dee2e6;
                          "
                        >
                          ردیف
                        </td>
                        <td
                          class="bg-primary-light"
                          style="
                            position: sticky;
                            top: -1px;
                            border: 1px solid #dee2e6;
                          "
                        >
                          کد
                        </td>
                        <td
                          class="bg-primary-light"
                          style="
                            position: sticky;
                            top: -1px;
                            border: 1px solid #dee2e6;
                          "
                        >
                          عنوان
                        </td>
                        <td
                          class="bg-primary-light"
                          style="
                            position: sticky;
                            top: -1px;
                            border: 1px solid #dee2e6;
                          "
                        >
                          تاریخ
                        </td>
                      </thead>
                      <!-- بدنه جدول -->
                      <tbody>
                        <tr
                          v-for="(row, index) in getListDataPaging"
                          :key="row.NCode"
                          :class="{ selRow: selectRow.NCode == row.NCode }"
                          v-on:click="selectRowVal(row.NCode, row.SDesc, row.SDate)"
                          v-on:dblclick="dblClickRow(row.NCode, row.SDesc, row.SDate)"
                          v-bind:id="'modal-' + row.NCode"
                          style="cursor: pointer;"
                        >
                          <td
                            style="
                              max-width: 50px;
                              white-space: nowrap;
                              text-overflow: ellipsis;
                              overflow: hidden;
                            "
                          >
                            {{ row.RowID }}
                          </td>
                          <td
                            style="
                              max-width: 120px;
                              white-space: nowrap;
                              text-overflow: ellipsis;
                              overflow: hidden;
                            "
                          >
                            {{ row.NCode }}
                          </td>
                          <td
                            style="
                              max-width: 120px;
                              white-space: nowrap;
                              text-overflow: ellipsis;
                              overflow: hidden;
                            "
                          >
                            {{ row.SDesc }}
                          </td>
                          <td
                            style="
                              max-width: 120px;
                              white-space: nowrap;
                              text-overflow: ellipsis;
                              overflow: hidden;
                            "
                          >
                            {{ row.SDate }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <PaginationBaseUsePlase class="mt-2" v-bind:Name="'TaragHesab'" v-bind:CountRow="intCountRow"
                      v-bind:DataRepository="TbModalDataFilter" v-on:ChangePage="ChangePage"></PaginationBaseUsePlase>

                </div>
              </div>
            </div>
          </div>
          <!-- پایان تب حساب ها -->
        </div>
        <div class="modal-footer bg-primary-light p-2">
          <div class="col-6 flex-fill">
            <div class="input-group px-1">
              <input
                type="text"
                autocomplete="off"
                id="textSearchBaseUsePlaceList"
                placeholder="جستجو در کد و عنوان (Enter)  ثبت (F4)"
                class="form-control form-control-sm rounded-0"
                v-on:focus="$event.target.select()"
                v-on:keyup.enter="filterData($event.target.value, $event)"
              />
              <div class="input-group-prepend rounded-0">
                <span
                  class="
                    input-group-text input-group-box-size
                    bg-primary
                    rounded-left
                    white-text
                  "
                >
                  <a v-on:click="filterData('Search')">
                    <i class="fas fa-search"></i>
                  </a>
                </span>
              </div>
            </div>
          </div>
          <div class="col-6 text-left">
            <button
              type="button"
              title="F4 انتخاب"
              class="btn btn-primary"
              v-on:click="SelectHesab()"
            >
              انتخاب مرکز هزینه (F4)
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              انصراف
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { BusEvent } from "../../../../../main.js";
import PaginationBaseUsePlase from "../../PublicComponents/Pagination.vue"

export default {
  components: {
    PaginationBaseUsePlase
  },
  data() {
    return {
      selectRow: {
        NCode: 0,
        SDesc: "",
        SDate: ""
      },

      // مربوط به صفحه بندی
      intPageNumber: 1,  // شماره صفحه در حال انتخاب
      intCountRow: 500,   // تعداد سطرها در هر صفحه
      intCountPage: 1,   // تعداد کل صفحه ها
      intCountRowShow: 1, // تعداد سطرهای مشاهده شده در صفحه - ممکن است صفحه 200 سطر کامل نباشد

      // ایندکس سطر در حال انتخاب
      indexRow: 0,
      // مخزن اصلی داده ها
      TbModalData: [],
      // مخزن داده های فیلتر شده
      TbModalDataFilter:[],

      NPerIDSearch: [],
    };
  },
  computed: {
    // نمایش اطلاعات با قابلیت صفحه بندی
    getListDataPaging() {
      if (this.TbModalDataFilter.length > 0) {
        // شماره شروع رکورد
        let startRowIndex = this.intPageNumber == 1 ? 1 : (parseInt(this.intCountRow) * (parseInt(this.intPageNumber) - 1) + 1);
        let intCountRowLocal = this.intCountRow;
        // انتخاب رکوردهای صفحه مورد نظر
        let ListTemplate = [];
        ListTemplate = this.TbModalDataFilter.filter(function (item) {
          return (item.RowID >= startRowIndex && item.RowID < (parseInt(startRowIndex) + parseInt(intCountRowLocal)))
        });
        // خروجی لیست صفحه مورد نظر
        return ListTemplate;
      } else {
        return [];
      }
    },
  },
  mounted() {
    // بررسی انصراف از نمایش مودال
    $("#modal-base-useplace").on("hidden.bs.modal", this.HideModal);
  },
  methods: {
    // رویداد تغییر صفحه از کامپاننت صفحه بندی
    ChangePage(value) {
      this.intPageNumber = value.pageNumber;
      this.intCountRow = value.countRow;
      this.intCountPage = value.countPage;
    },
    // لغو مودال کد حساب و طرف حساب
    HideModal() {
      // لحظه بسته شدن مودال
      if (this.selectRow.NCode == 0) {
        this.$emit("HideModal", {
          NCode: 0,
          SDesc: "",
          SDate: ""
        });
      } else {
        this.$emit("HideModal", {
          NCode: this.selectRow.NCode,
          SDesc: this.selectRow.SDesc,
          SDate: this.selectRow.SDate
        });
      }
    },

    // فیلتر لیست حساب ها
    async filterData(searchValue, event) {
      if (searchValue === "Search") {
        searchValue =
          $("#textSearchBaseUsePlaceList").val() != ""
            ? $("#textSearchBaseUsePlaceList").val()
            : "";
      }      
      
      // لغو فراخوانی جستجو در صورت کلیک فلش بالا و پایین
      try{
        if(event.key.toString() === "ArrowDown" || event.key.toString() === "ArrowUp"){
          $("#textSearchBaseUsePlaceList").select();
          return true;
        }
      } catch (e) {}

      if (searchValue != "") {
        // فیلتر اطلاعات بر اساس مقدار درج شده توسط کاربر
        this.TbModalDataFilter =
          this.TbModalData.filter(function(itme){
            return (itme.NCode.toString().startsWith(searchValue) ||
              itme.SDesc.toString().includes(searchValue))
          });
        if(this.TbModalDataFilter.length > 0){
          // درج شماره ردیف برای لیست
          this.TbModalDataFilter = await this.$store.dispatch('setRowIDForList', this.TbModalDataFilter);
                    
          if(this.TbModalDataFilter.length < this.indexRow) this.indexRow = 0;
          // ذخیره سطر پیدا شده
          this.selectRow.NCode =  this.TbModalDataFilter[this.indexRow].NCode;
          this.selectRow.SDesc = this.TbModalDataFilter[this.indexRow].SDesc;
          this.selectRow.SDate = this.TbModalDataFilter[this.indexRow].SDate;
        }
      } else {
        this.TbModalDataFilter = this.TbModalData;
      }
    },

    // جستجو در لیست حساب ها
    searchData(searchValue, event) {
      if (searchValue != "") {
        // جستجوی مقدار درج شده توسط کاربر
        // و انتقال نمایش به سطر جستجو شده
        let index = this.TbModalData.findIndex(
          (itme) =>
            itme.NCode.toString().startsWith(searchValue) ||
              itme.SDesc.toString().includes(searchValue)
        );
        if (index != -1) {
          let NCode = this.TbModalData[index].NCode;
          $("#modal-" + NCode).scrollintoview({
            duration: 500,
            //complete: this.$store.dispatch("notify", "تست نمایش پیام"),
          });
          this.NPerIDSearch.push(NCode);
          // ذخیره سطر پیدا شده
          this.selectRow.NCode = NCode;
          this.selectRow.SDesc = this.TbModalData[index].SDesc;
          this.selectRow.SDate = this.TbModalData[index].SDate;
        }
      }
    },

    async getTbModalData() {
      this.TbModalData = await this.$store.getters.getTbBaseUsePlaceData;
      this.TbModalDataFilter = this.TbModalData;
    },

    dblClickRow(NCode, SDesc, SDate) {
      this.selectRowVal(NCode, SDesc, SDate);
      this.SelectHesab();
    },

    selectRowVal(NCode, SDesc, SDate) {
      this.selectRow.NCode = NCode;
      this.selectRow.SDesc = SDesc;
      this.selectRow.SDate = SDate;
    },

    SelectHesab() {
      if (this.selectRow.NCode == 0) {
        this.$store.dispatch("notify", {
          notText:
            "سطری در حالت انتخاب نیست !\nلطفا ابتدا یکی از سطرها را در حالت انتخاب قرار دهید .",
          timeOut: 2500,
        });
      } else {
        this.NPerIDSearch = [];
        // بستن مودال
        $("#modal-base-useplace").modal("hide");
      }
    },

    setFocusTextSearch(value) {
      setTimeout(() => {
        $("#textSearchBaseUsePlaceList").focus();
        if (value != "") {
          $("#textSearchBaseUsePlaceList").val(value);
          $("#textSearchBaseUsePlaceList").select();
          this.filterData('Search');
        }
      }, 200);
    },

    // تابع مدیریت کلید میانبرها داخل سند
    hotKeyChecker(keyvalue) {
      if (this.TbModalDataFilter.length > 0) {
        if (keyvalue.key === "ArrowUp" || keyvalue.key === "ArrowDown") {
          let index = this.TbModalDataFilter.findIndex(
            (itme) => itme.NCode == this.selectRow.NCode
          );
          if (index != -1) {
            if (keyvalue.key === "ArrowUp") {
              if (index > 0) {
                this.selectRowVal(
                  this.TbModalDataFilter[index - 1].NCode,
                  this.TbModalDataFilter[index - 1].SDesc,
                  this.TbModalDataFilter[index - 1].SDate
                );
                $("#modal-" + this.TbModalDataFilter[index - 1].NCode).scrollintoview({
                  duration: 100,
                  //complete: this.$store.dispatch("notify", "تست نمایش پیام"),
                });
                this.indexRow = index - 1;
              }
            } else {
              if (index + 1 < this.TbModalDataFilter.length) {
                this.selectRowVal(
                  this.TbModalDataFilter[index + 1].NCode,
                  this.TbModalDataFilter[index + 1].SDesc,
                  this.TbModalDataFilter[index + 1].SDate
                );
                $("#modal-" + this.TbModalDataFilter[index + 1].NCode).scrollintoview({
                  duration: 100,
                  //complete: this.$store.dispatch("notify", "تست نمایش پیام"),
                });
                this.indexRow = index + 1;
              }
            }
          } else {
            this.selectRowVal(
              this.TbModalDataFilter[0].NCode,
              this.TbModalDataFilter[0].SDesc,
              this.TbModalDataFilter[0].SDate
            );
            this.indexRow = 0;
          }
        }
        // انتخاب سطر و بستن پنجره
        if (keyvalue.key === "F4") {
          this.SelectHesab();
        }
      }
    },
  },
  created() {
    this.getTbModalData();
    BusEvent.$on("setFocuseTextSearchBaseUsePlace", this.setFocusTextSearch);
    BusEvent.$on("keyPressValue", this.hotKeyChecker);
  },
  beforeDestroy() {
    BusEvent.$off("setFocuseTextSearchBaseUsePlace", this.setFocusTextSearch);
    BusEvent.$off("keyPressValue", this.hotKeyChecker);
  },
};
</script>

<style scoped>
.selRow{
  background-color: #fbff94;
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/NewAccDoc/Components/ModalBaseUsePlaceList.vue